import { AppConfig } from './../../../../../environments/appconfig';
import { SeguridadUsuarioLogin } from './../../../framework/modelo/seguridad/SeguridadUsuarioLogin';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, SelectItem } from 'primeng/api';
import { BaseComponent } from '@framework/angular/component/BaseComponent';
import { LoginService } from '@framework-seguridad/servicio/autorizacion/seguridad/login.service';
import { ServicioComunService } from '@framework-comun/servicioComun.service';
import { NoAuthorizationInterceptor } from '@framework/angular/interceptor/NoAuthorizationInterceptor';
import { ConstanteAngular } from '@framework/angular/ConstanteAngular';
import { UsuarioService } from '@framework-seguridad/servicio/spring/seguridad/usuario.service';
import { DtoTabla } from '@framework/modelo/generico/dto/DtoTabla';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { DtoConfiguracionLogin } from '../dominio/DtoConfiguracionLogin';

type ProfileType = {
  businessPhones?: string,
  displayName?: string,
  givenName?: string,
  jobTitle?: string,
  mail?: string,
  mobilePhone?: string,
  officeLocation?: string,
  preferredLanguage?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
}

@Component({
  selector: 'app-comunlogin',
  templateUrl: './app.comun-login.component.html',
  styleUrls: ['./app.comun-login.component.scss']
})
export class AppComunLoginComponent extends BaseComponent {

  profile!: ProfileType;
  private readonly _destroying$ = new Subject<void>();
  loginDisplay = false;

  companias: SelectItem[] = [];
  usuario: SeguridadUsuarioLogin = new SeguridadUsuarioLogin();
  mensajeAMostrar: string;
  verMensaje: boolean = false;
  logo = "";
  logobox = "";

  verLogin: boolean = true;
  verRecuperarClave: boolean = false;
  verGenerandoToken: boolean = false;

  correo: string = ''
  form: boolean = false

  dtoConfiguracionLogin:DtoConfiguracionLogin = new DtoConfiguracionLogin();

  constructor(
    private http: HttpClient,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private loginService: LoginService,
    private router: Router,
    private config: AppConfig,
    public usuarioService: UsuarioService,
    noAuthorizationInterceptor: NoAuthorizationInterceptor,
    messageService: MessageService,
    servicioComun: ServicioComunService
  ) {
    super(noAuthorizationInterceptor, messageService, servicioComun);
    this.loginService.configuracionLogin().then(res=>{
      this.dtoConfiguracionLogin = res;
    });
  }

  ngOnInit() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
    this.logo = `assets/imagenes/${this.config.getEnv('recursos-companias')}/agrobanco.png`;
    this.logobox = `assets/imagenes/${this.config.getEnv('recursos-companias')}/logobox.png`;
    this.usuario.tipoUsuarioId = "EMPL";
    this.companias.push({ label: 'Seleccione', value: null })
  }

  entrando: number = 0;

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      if (this.entrando == 0) {
        this.entrando = 1;
        this.bloquearPagina();

        this.verLogin = false;
        this.verRecuperarClave = false;
        this.verGenerandoToken = true;

        this.http.get('https://graph.microsoft.com/v1.0/me').subscribe(profile => {
          this.profile = profile;
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ha ocurrido un error' });
          Promise.all([this.timeout_(5000)]).then((resp) => {
            this.logout();
          });
        });

        const account = this.authService.instance.getAllAccounts()[0];
        const accessTokenRequest = { scopes: ["user.read"], account: account };
        console.log('acquireTokenSilent');
        this.authService.acquireTokenSilent(accessTokenRequest).subscribe(accessTokenResponse => {
          let accessToken = accessTokenResponse.accessToken;
          localStorage.setItem("access_token", accessToken);
          console.log('generarTokenAD');
          this.loginService.generarTokenAD().then(obj => {
            this.desbloquearPagina();
            if (obj != null) {
              this.usuario.token = obj.token;
              if (!this.esListaVacia(obj.transaccionListaMensajes)) {
                this.bloquearPagina();
                this.messageService.clear();
                for (let i = 0, len = obj.transaccionListaMensajes.length; i < len; i++) {
                  if (obj.transaccionListaMensajes[i].tipoMensaje.toString() === 'ADVERTENCIA') {
                    this.messageService.add({ severity: 'warn', summary: 'Mensaje', detail: obj.transaccionListaMensajes[i].mensaje });
                  } else if (obj.transaccionListaMensajes[i].tipoMensaje.toString() === 'INFORMACION') {
                    this.messageService.add({ severity: 'info', summary: 'Mensaje', detail: obj.transaccionListaMensajes[i].mensaje });
                  } else {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: obj.transaccionListaMensajes[i].mensaje });
                  }
                }

                Promise.all([this.timeout_(5000)]).then((resp) => {
                  this.logout();
                });

              } else {
                if (obj != null) {
                  localStorage.setItem('access_login', ConstanteAngular.LOGINSEGURIDAD);
                  localStorage.setItem('access_token', obj.token);
                  localStorage.setItem('logo_company', obj.logo);
                  this.irDashboard();
                  this.irDashboard();
                } else {
                  this.desbloquearPagina();
                  this.logout();
                }
              }
            } else {
              this.desbloquearPagina();
              this.logout();
            }
          });
        });

        this.entrando = 1;
      }
    }
  }

  login(): void {
    this.bloquearPagina();
    this.usuario.idioma = "es"
    this.loginService.ingresar(this.usuario).then(
      obj => {
        if (obj != null) {
          this.usuario.token = obj.token;
          if (!this.esListaVacia(obj.transaccionListaMensajes)) {
            this.desbloquearPagina();
            for (let i = 0, len = obj.transaccionListaMensajes.length; i < len; i++) {
              if (obj.transaccionListaMensajes[i].tipoMensaje.toString() === 'ADVERTENCIA') {
                this.mensajeAMostrar = obj.transaccionListaMensajes[i].mensaje;
                this.verMensaje = true;
              } else if (obj.transaccionListaMensajes[i].tipoMensaje.toString() === 'INFORMACION') {
                this.mensajeAMostrar = obj.transaccionListaMensajes[i].mensaje;
              } else {
                this.messageService.add({
                  severity: 'error', summary: 'Error',
                  detail: obj.transaccionListaMensajes[i].mensaje
                });
              }
            }
          } else {
            if (obj != null) {
              localStorage.setItem('access_login', ConstanteAngular.LOGINSEGURIDAD);
              localStorage.setItem('access_token', obj.token);
              localStorage.setItem('logo_company', obj.logo);
              this.irDashboard();
            } else {
              this.desbloquearPagina();
            }
          }
        } else {
          this.desbloquearPagina();
        }
      }
    );
  }

  recuperarclave() {
    this.verGenerandoToken = false;
    this.verLogin = false;
    this.verRecuperarClave = true;
    this.usuario.cambioclave = false
  }

  enviarClave() {
    if (this.estaVacio(this.correo)) {
      this.mostrarMensajeAdvertencia("Debe ingresar el usuario");
      return;
    }

    this.bloquearPagina();
    var dto = new DtoTabla();
    dto.codigo = this.correo;
    dto.estado = "es"
    this.loginService.recuperarClave(dto).then(
      resp => {

        this.desbloquearPagina();
        if (!this.esListaVacia(resp)) {
          for (let i = 0, len = resp.length; i < len; i++) {
            this.messageService.add({
              severity: 'error', summary: 'Error',
              detail: resp[i].mensaje
            });
          }
        } else {
          this.mostrarMensajeExito("Se le ha enviado un correo con la contraseña temporal");
          this.verRecuperarClave = false;
          this.salir()
        }
      }
    );
  }

  salir() {
    this.correo = "";
    this.verRecuperarClave = false;
    this.verGenerandoToken = false;
    this.verLogin = true;
    this.usuario.cambioclave = false
  }

  cargarCompaniasPorUsuario() {
    if (this.estaVacio(this.usuario.usuario)) {
      this.companias = [];

      return;
    }
    this.loginService.wf_setup_compania_usuario(this.usuario)
      .then(
        res => {
          this.desbloquearPagina();
          if (res != null) {
            this.companias = [];
            res.forEach(obj => this.companias.push({ label: obj.nombre, value: obj.codigo }));
            if (res.length > 0) {
              this.usuario.companiaCodigo = res[0]?.descripcion;
            } else {
              this.usuario.companiaCodigo = null;
            }
          }
        }
      );
  }

  ingresarAlSistema() {
    localStorage.setItem('access_token', this.usuario.token);
    this.irDashboard();
  }

  irDashboard() {
    this.usuarioService.wf_getmodules().then(
      resp => {
        sessionStorage.setItem("modules", JSON.stringify(resp))
        this.router.navigate(['portal']);
      }
    );
  }


  loginAD() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  }
}
